export default __webpack_public_path__ + "static/media/hotspot.07aa0959.svg";